<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_131_7467)">
      <path
        d="M11.0832 3.73917L10.2607 2.91667L6.99984 6.17751L3.739 2.91667L2.9165 3.73917L6.17734 7.00001L2.9165 10.2608L3.739 11.0833L6.99984 7.82251L10.2607 11.0833L11.0832 10.2608L7.82234 7.00001L11.0832 3.73917Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
